module.exports = __webpack_public_path__ + "static/media/google.f9575a30.png";